export interface IPagination {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export function calculatePagination(totalItems: number, pageSize: number, pageNumber: number): IPagination {
  const totalPages = Math.ceil(totalItems / pageSize);

  return {
    pageNumber,
    pageSize,
    totalPages,
  };
}

type SortFunction<T> = (a: T, b: T) => number;

/**
 * filter items in memory. consider changing DB queries to filter/paginated on DB level instead
 */
export function filterPageItemsInMemory<T>(items: T[], pagination: IPagination, sortFunction?: SortFunction<T>): T[] {
  if (sortFunction) {
    const sorted = items.sort(sortFunction);
    return filterPageItemsInMemory(sorted, pagination);
  }

  const startIndex = (pagination.pageNumber - 1) * pagination.pageSize;
  const endIndex = startIndex + pagination.pageSize;
  return items.slice(startIndex, endIndex);
}
